import { Injectable, NgModule } from '@angular/core';
/**
 * LocalStoreService. Basic wraper for localStorage
 */
var LocalStoreService = (function () {
    function LocalStoreService() {
    }
    /**
     * Stores Value in localstorage
     * @param key
     * @param value
     */
    LocalStoreService.prototype.storeValue = function (key, value) {
        localStorage.setItem(key, value);
        // storage.set(key, value, callback);
    };
    /**
     * Gets a value from localstorage
     * @param key
     * @returns {any}
     */
    LocalStoreService.prototype.getValue = function (key) {
        return localStorage.getItem(key);
        // return storage.get(key, callback);
    };
    /**
     * Clears a value from localstorage
     * @param key
     */
    LocalStoreService.prototype.clearValue = function (key) {
        localStorage.removeItem(key);
    };
    /**
     * Clears all localstorage
     */
    LocalStoreService.prototype.clear = function () {
        localStorage.clear();
    };
    return LocalStoreService;
}());
export { LocalStoreService };
LocalStoreService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
LocalStoreService.ctorParameters = function () { return []; };
var DotLocalStoreModule = (function () {
    function DotLocalStoreModule() {
    }
    return DotLocalStoreModule;
}());
export { DotLocalStoreModule };
DotLocalStoreModule.decorators = [
    { type: NgModule, args: [{
                providers: [LocalStoreService]
            },] },
];
/** @nocollapse */
DotLocalStoreModule.ctorParameters = function () { return []; };
//# sourceMappingURL=local-store.service.js.map